// ONE filled button per screen (design audit A11) — the half of that rule
// that spans components.
//
// Several controls turn primary the moment they become useful: the DNS save
// once the owner has typed a URL, "Set password" once the password is long
// enough, the domain Search once the query is. Each is correct on its own,
// and each sits on the Website screen, whose header shows Launch while the
// site is still in development mode. Launch is the bigger, rarer act — the
// one thing the screen is for until the site is live — so it keeps the
// single fill and everything else stays outline even when it is ready
// (operator ruling, design audit T8 → T14).
//
// `claimed` is passed down from the screen that knows (foundation/website.tsx
// owns Launch). Components mounted anywhere else — the setup wizard's
// foundation step, for one — leave it false and keep their own behaviour.
export function readyPrimaryVariant(ready: boolean, claimed = false): 'default' | 'outline' {
  return ready && !claimed ? 'default' : 'outline';
}
